<template>
  <!-- <v-container> -->
  <v-card elevation="0" class="my-4 mx-4" v-if="autorizacion" color="#F5F5F5">
    <v-card-text>
      <v-alert
        v-if="accesoRevocado"
        prominent
        type="error"
        border="left"
      >
        Sus permisos para consultar este toca fueron revocados
        <span v-if="fechaRevocacionEfectiva"> el {{ fechaRevocacionEfectiva | formatDate }}</span>.
        Si considera que se trata de un error, contacte a la Secretaría de Acuerdos.
      </v-alert>
      <div v-if="!accesoRevocado && !apelacion">
        <v-skeleton-loader
          type="actions, article, card"
        ></v-skeleton-loader>
      </div>
      <div v-else-if="!accesoRevocado && apelacion">
        <div class="" style="background-color: #1D2E4B;">
          <div class="mx-auto" style="width: 90%;">
            <v-row>
              <v-col cols="12">
                <div class="my-12 mt-0">
                  <!-- <v-btn color="#0A4A79" class="mr-1" dark :to="'/tocas/list'" small>
                    <v-icon small class="mr-3">mdi-arrow-left</v-icon>
                    Ir a Panel
                  </v-btn> -->
                  <v-btn
                    dark
                    text
                    @click="$router.push({ name:'TocasList' })"
                    style="float: right;"
                  >
                    <v-icon
                      right
                      dark
                      class="mr-1"
                    >
                      mdi-arrow-left
                    </v-icon>
                    Ir a Panel
                  </v-btn>
                  <h1
                    v-if="apelacion"
                    class="white--text text-center pb-3 pt-10 text-h3"
                  >
                    TOCA {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
                    <span v-if=" apelacion.toca.complemento">
                      -{{  apelacion.toca.complemento }}
                    </span>
                  </h1>
                  <div class="ul-invoice-v1-header d-flex flex-wrap justify-center align-center">
                  <p
                    class="ma-0 mb-n6 grey--text text--lighten-3 font-weight-medium"
                  >
                    Sala {{ autorizacion.sala_id }}
                  </p>
                  </div>
                  <v-divider dark class="my-12" style="background-color: #CDA74A;"></v-divider>
                </div>
                <div
                    class="d-flex justify-space-between flex-wrap py-10 mt-n10 pb-0 pt-3"
                >
                  <div class="mb-8 d-flex flex-column max-w-xs">
                    <span
                        class="white--text font-weight-medium text-18"
                    >PONENCIA
                    </span>
                    <span
                      v-if="apelacion.toca && !apelacion.toca.ponencia"
                      class="grey--text text--lighten-3 font-weight-medium text-18">
                      Sin asignar<br>
                    </span>
                    <span
                      v-else-if="apelacion.toca && apelacion.toca.ponencia"
                      class="grey--text text--lighten-3 font-weight-medium text-18">
                      {{ apelacion.toca.ponencia.magistrado }}<br>
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-row>
          <v-col cols="12">
            <v-card elevation="2">
              <v-card-text>
                <!-- DETALLES -->
                <v-row 
                  class="mt-1 mb-2 pa-2 font-weight-bold white--text"
                  style="background-color: #7E96A8; border-radius: 6px;"
                  color="#7E96A8" 
                  dark 
                  dense
                >
                  <h3 class="text-uppercase">DETALLES</h3>
                </v-row>
                <v-row>
                  <v-col class="mt-n3">
                    <template>
                      <v-card-text>
                        <span style="color: #225882"><b>Se autoriza el acceso a:</b> </span> 
                        <span v-if="ciudadano" style="color: #676767" class="ml-2"><u> {{ciudadano.nombre }} {{ciudadano.primer_apellido }} {{ciudadano.segundo_apellido }}</u></span><br>
                        <span style="color: #225882"><b>Email:</b> </span> <span v-if="ciudadano" style="color: #676767" class="ml-2"><u> {{ciudadano.email}} </u></span><br>
                        <span style="color: #225882"><b>Fecha autorización:</b> </span> <span style="color: #676767" class="ml-2"><u> {{autorizacion.fecha_autorizacion | formatDate }} </u></span><br>
                        <h4 v-if="autorizacion.num_expediente"><span style="color: darkslategrey">Expediente: {{autorizacion.num_expediente}}</span></h4>
                        <!-- <span style="color: #225882"><b>Sala:</b> </span> <span style="color: #676767" class="ml-2"><u>{{ autorizacion.sala_id }} </u></span><br>
                        <span style="color: #225882"><b>Magistrado:</b> </span> 
                        <span v-if="apelacion.toca && !apelacion.toca.ponencia" style="color: #676767" class="ml-2"><u> Sin asignar</u></span>
                        <span v-else-if="apelacion.toca && apelacion.toca.ponencia" style="color: #676767" class="ml-2"><u> {{ apelacion.toca.ponencia.magistrado }}</u></span><br> -->
                      </v-card-text>
                    </template>
                  </v-col>
                </v-row>
                <!-- DOCUMENTOS APELACIÓN ELECTRÓNICA -->
                <v-row 
                  class="mt-1 mb-2 pa-2 font-weight-bold white--text"
                  style="background-color: #7E96A8; border-radius: 6px;"
                  color="#7E96A8" 
                  dark 
                  dense
                >
                  <h3 class="text-uppercase">APELACIÓN ELECTRÓNICA</h3>
                </v-row>
                <div
                  class="mb-n2"
                >
                  <v-card flat>
                    <v-card-text>
                      <v-row  v-if="apelacion.apelacion_electronica" class="mb-n1">
                        <v-col cols="12" sm="6">
                          <h3 v-if="apelacion.apelacion_electronica.numero_carpeta">NUM. DE CARPETA ADMINISTRATIVA:<span style="color: #225882"> {{apelacion.apelacion_electronica.numero_carpeta}}</span></h3>
                          <v-divider></v-divider>
                          <h3 v-if="apelacion.apelacion_electronica.num_oficio">NUM. DE OFICIO:<span style="color: #225882"> {{ apelacion.apelacion_electronica.num_oficio }} </span></h3>
                          <v-divider></v-divider>
                          <div v-if="apelacion.apelacion_electronica.nombre_creador">
                            <span class="font-weight-small black--text mr-3"  style="color: #225882">CREADOR:</span><b>{{ apelacion.apelacion_electronica.nombre_creador }}</b><br>
                          </div>
                          <v-divider></v-divider>
                          <span v-if="apelacion.apelacion_electronica.nombre_juzgado" class="font-weight-small black--text mr-3">JUZGADO:</span><b>{{ apelacion.apelacion_electronica.nombre_juzgado }}</b><br>
                          <v-divider></v-divider>
                        </v-col>

                        <v-col cols="12" sm="6" dark>
                          <span class="mr-3" v-if="apelacion.apelacion_electronica.hash"> <b>HASH:</b> <b style="color:#D81B60;font-size:22px">{{ apelacion.apelacion_electronica.hash }} </b></span>
                          <v-divider></v-divider>
                          <span class="font-weight-small black--text mr-3" v-if="apelacion.apelacion_electronica !=0 && apelacion.apelacion_electronica.fecha_envio">
                            Fecha de envio:
                          </span>
                          <u v-if="apelacion.apelacion_electronica !=0">{{apelacion.apelacion_electronica.fecha_envio | formatDate}}<br></u>
                          <span class="font-weight-small black--text mr-3" v-if="apelacion.apelacion_electronica.status">
                            Estatus:
                          </span>
                          <u v-if="apelacion.apelacion_electronica.status == 30 ">Turnada Sala {{ apelacion.apelacion_electronica.sala_id }}<br></u>
                        </v-col>
                      </v-row>

                      <v-row v-if="apelacion.apelacion_electronica">
                        <v-col cols="12" sm="6">
                            <v-divider class="mt-2"></v-divider>
                            <div v-for="(doc, i) in apelacion.apelacion_electronica.documentos" :key="'doc_'+ i">
                              <h3 class=" mt-2">
                                <span v-if="doc.tipo == 1" style="color: darkslategrey">
                                  APELACIÓN ELECTRÓNICA:
                                </span>
                                <span v-if="doc.tipo == 2" style="color: darkslategrey">
                                  CARPETA ADMINISTRATIVA:
                                </span>
                                <span v-if="doc.tipo == 3" style="color: darkslategrey">
                                  CERTIFICACION DE CARPETA ADTVA.:
                                </span>
                                <v-btn
                                  x-small
                                  color="indigo"
                                  dark
                                  class="ml-2"
                                  @click="getFilePresignedUrl(doc, 'doc_apelaciones')"
                                >
                                  <v-icon left x-small>
                                    mdi-eye
                                  </v-icon>
                                  Ver documento
                                </v-btn>
                              </h3>
                              <v-divider class="mt-2"></v-divider>
                            </div>
                        </v-col>
                      </v-row>
                      <!-- VIDEOS APELACIÓN ELECTRÓNICA -->
                      <v-row> 
                        <v-col cols="12" md="12" class="mt-2 mb-3" v-if="apelacion.apelacion_electronica && apelacion.apelacion_electronica.videos">
                          <h3 class="indigo--text">VIDEO AUDIENCIAS:</h3>
                          <h3 v-if="!apelacion.apelacion_electronica.videos.length">
                            <li>La apelación electrónica no contiene videos.</li>
                          </h3>
                          <ul v-for="(video, i) in apelacion.apelacion_electronica.videos" :key="i">
                            <li class="ml-n3">
                              <h3>
                                {{ video.file_name }}
                                
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-btn
                                        small
                                        color="teal"
                                        icon
                                        dark
                                        class="ml-5"
                                        @click="getFilePresignedUrl(video, 'video_apelaciones')"
                                      >
                                        <v-icon>
                                          mdi-video
                                        </v-icon>
                                      </v-btn>&nbsp;
                                    </span>
                                  </template>
                                    <span>Ver Video Audiencia</span>
                                </v-tooltip>
                              </h3>
                            </li>
                            <v-divider></v-divider>
                          </ul>
                        </v-col>
                      </v-row>
                      <!--  dialog loading -->
                      <v-dialog
                        v-model="progress"
                        persistent
                        width="300"
                      >
                        <v-card
                          color="#0A4A79"
                          dark
                        >
                          <v-card-text>
                            Cargando Archivo
                            <v-progress-linear
                              indeterminate
                              color="white"
                              class="mb-0"
                            ></v-progress-linear>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-card-text>
                  </v-card>
                  <!-- DOCUMENTOS DEL TOCA (APELACIÓN) SISGEO -->
                  <v-row 
                    class="mt-1 mb-2 pa-2 font-weight-bold white--text"
                    style="background-color: #7E96A8; border-radius: 6px;"
                    color="#7E96A8" 
                    dark 
                    dense
                  >
                    <h3 class="text-uppercase">DOCUMENTOS</h3>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      style="background-color:#0A4A79"
                      class="mr-1"
                      dark
                      @click="createUploadDoc()"
                    >
                      <v-icon small dark class="mr-1">mdi-plus</v-icon> Presentar Escrito
                      <div class="flex-grow-1"></div>
                    </v-btn>
                  </v-row>
                  <div>
                    <!-- ENCABEZADOS -->
                    <v-row class="mt-1 mb-2 font-weight-bold align-center" justify="center">
                      <v-col cols="12" sm="3">
                        Tipo de documento
                      </v-col>
                      <v-col cols="12" sm="2">
                        Extracto
                      </v-col>
                      <v-col cols="12" sm="3">
                        Datos del archivo
                      </v-col>
                      <v-col cols="12" sm="4">
                        Acciones
                      </v-col>
                    </v-row>
                  </div>
                  <div
                    class="mb-n2"
                    v-for="(doc, i) in apelacion.documentos"
                    :key="'doc_'+i"
                  >
                    <v-divider v-if="doc.url_evidencia && doc.url_original"></v-divider>
                    <!-- DOCUMENTOS -->
                    
                    <v-row 
                      v-if="doc.url_evidencia && doc.url_original"
                      class="mt-1 mb-2 pa-2 font-weight-bold align-center"
                      justify="center"
                    >
                      <v-col cols="12" sm="3">
                        <!-- {{ doc.tipo_documento }}<br> -->
                        <span v-if="doc.leyenda" class="font-weight-regular"><b>{{doc.leyenda.toUpperCase()}} </b></span>
                        <span v-else class="font-weight-regular"><b>{{ doc.tipo_documento.nombre.toUpperCase() }}</b></span><br>
                        <!-- <span class="font-weight-regular">{{doc.leyenda}} </span><br> -->
                      
                      </v-col>
                      <v-col cols="12" sm="2">
                        <span v-if="doc.extracto" class="font-weight-regular"> {{doc.extracto}} </span>
                      </v-col>
                      
                      <v-col cols="12" sm="3">
                        <b>Nombre: </b><span class="font-weight-regular">{{ doc.nombre_original }}</span><br>
                        <b>Tamaño: </b>

                        <span class="font-weight-regular" v-if="doc.url_evidencia">
                          {{ doc.size_original | megas }} MB
                        </span><br>
                        Creado el día:  {{ doc.created_at | formatDate }}
                        <div v-if="doc.email == getUser.email && doc.plataforma === 'Ciudadano'">
                          <b>Creado por: </b>
                          <span v-if="getUser.segundo_apellido">
                            {{ getUser.nombre }} {{ getUser.primer_apellido }} {{ getUser.segundo_apellido }}
                          </span>
                          <span v-else>
                            {{ getUser.nombre }} {{ getUser.primer_apellido }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <div class="d-flex align-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-img v-if="doc.url_evidencia"
                                :src="path_logo_pdf"
                                @click="getFilePresignedUrl(doc, 'doc_sisgeo')"
                                v-on="on"
                                style="max-height: 33px; max-width: 33px; cursor: pointer"/>
                            </template>
                            <span>Ver documento con firma electrónica </span>
                          </v-tooltip>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <v-icon
                                  v-if="doc.email === getUser.email && doc.plataforma == 'Ciudadano'"
                                  large
                                  color="blue"
                                  icon
                                  dark
                                  class="ml-5"
                                >
                                  mdi-account-file-outline
                                </v-icon>
                              </span>
                            </template>
                            <span>Documento agregado por {{ getUser.nombre }} {{getUser.primer_apellido}}</span>
                          </v-tooltip> -->
                        </div>
                      </v-col>
                    </v-row> 
                  </div>
                </div>
                <v-divider></v-divider>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card>
          <v-dialog
            v-if="dialog"
            v-model="dialog"
            persistent
            max-width="1100px"
          >
            <Promociones
              :autorizacion="autorizacion" 
              @close="closeUploadDoc"
              @showToca="showToca"
            />
          </v-dialog>
        </v-card>
      </div>
      
    </v-card-text>

  </v-card>
<!-- </v-container> -->
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import Promociones from "@/components/Promociones";

  export default {
    components: {
      Promociones
    },
    data(){
      return{
        path_logo_pdf:require('@/assets/img/file-pdf.svg'),
        autorizacion:'',
        apelacion:'',
        ciudadano: '',
        toca_id: '',
        apelacion_id: '',
        // currentToca:'',
        progress: false,
        dialog: false,
        loading:false,
        alert:true,
        url_leido:'',
        messages_viabilidad:[],
        valid: true,
        loading: false,
        eFirmaDialog: false,
        acuerdo_firmado: false,
        efirma:{
          user: '',
          password: ''
        },
        url:'',
        juez:'',
        promocion_id:''
      }
    },
    filters: {
      megas: function (value) {
        if (!value) return ''
        value = value / 1048576
        return value.toFixed(2);
      },
    },
    computed: {
      accesoRevocado () {
        return !!(this.autorizacion && (this.autorizacion.esta_revocada || this.autorizacion.fecha_revocacion))
      },
      fechaRevocacionEfectiva () {
        if (!this.autorizacion) {
          return null
        }
        return this.autorizacion.fecha_revocacion || null
      },
      mensajeRevocacion () {
        if (!this.fechaRevocacionEfectiva) {
          return 'Sus permisos para consultar este toca fueron revocados.'
        }
        return 'Sus permisos para consultar este toca fueron revocados el '
          + this.$options.filters.formatDate(this.fechaRevocacionEfectiva) + '.'
      },
      formTitle () {

      },
      btnTitle () {

      },
      ...mapGetters(["roleUser", "getUser"]),
    },
    mounted() {
      this.autorizacion = JSON.parse(localStorage.getItem("currentToca"))
      if (!this.autorizacion) {
        this.$router.push({ name: 'TocasList' })
        return
      }
      this.showToca()
    },
    methods:{
      showToca() {
        this.$store.dispatch("GET_TOCAS", {
          url: "/autorizacion",
          params: {
            sala_id: this.autorizacion.sala_id,
            apelacion_id: this.autorizacion.apelacion_id,
            autorizacion_id: this.autorizacion.id
          }
        })
          .then((response) => {
            if (response.data.status === 'error' || response.data.success === false) {
              throw { response: { data: response.data } }
            }
            this.autorizacion = response.data.autorizacion || this.autorizacion
            localStorage.setItem('currentToca', JSON.stringify(this.autorizacion))
            if (this.accesoRevocado) {
              return
            }
            this.apelacion = response.data.data.data.apelacion
            this.ciudadano = response.data.autorizacion.ciudadano
          })
          .catch(err => {
            console.log(err);
            const payload = err.response && err.response.data ? err.response.data : {}
            if (payload.autorizacion && payload.autorizacion.fecha_revocacion) {
              localStorage.setItem('currentToca', JSON.stringify(payload.autorizacion))
            }
            if (err.response && err.response.status === 403) {
              return
            }
            const message = payload.message
              ? payload.message
              : 'No fue posible cargar el toca.'
            this.$swal({
              title: 'Acceso no permitido',
              text: message,
              icon: 'warning',
              confirmButtonText: 'Regresar',
            }).then(() => {
              this.$router.push({ name: 'TocasList' })
            })
          });
      },
      createUploadDoc(){
        if (this.accesoRevocado) {
          this.redirigirPorAccesoRevocado(this.mensajeRevocacion)
          return
        }
        this.loading = true
        this.$store.dispatch("GET_TOCAS", {
          url: "/autorizacion",
          params: {
            sala_id: this.autorizacion.sala_id,
            apelacion_id: this.autorizacion.apelacion_id,
            autorizacion_id: this.autorizacion.id
          }
        }).then((response) => {
          this.loading = false
          if (response.data.status === 'error' || response.data.success === false) {
            throw { response: { data: response.data } }
          }
          this.autorizacion = response.data.autorizacion || this.autorizacion
          localStorage.setItem('currentToca', JSON.stringify(this.autorizacion))
          if (this.accesoRevocado) {
            this.redirigirPorAccesoRevocado(this.mensajeRevocacion)
            return
          }
          this.dialog = true
        }).catch(err => {
          this.loading = false
          const payload = err.response && err.response.data ? err.response.data : {}
          if (payload.autorizacion && payload.autorizacion.fecha_revocacion) {
            this.autorizacion = payload.autorizacion
            localStorage.setItem('currentToca', JSON.stringify(payload.autorizacion))
          }
          if (err.response && err.response.status === 403) {
            return
          }
          this.redirigirPorAccesoRevocado(
            payload.message || 'No fue posible verificar su autorización para este toca.'
          )
        })
      },
      redirigirPorAccesoRevocado (message) {
        this.$swal({
          title: 'Acceso no permitido',
          text: message,
          icon: 'warning',
          confirmButtonText: 'Aceptar',
        }).then(() => {
          this.dialog = false
          this.$router.push({ name: 'TocasList' })
        })
      },
      closeUploadDoc(val) {
        this.dialog = false
        if (val === 'revoked') {
          this.$router.push({ name: 'TocasList' })
        }
      },
      // leido() {
      //   this.$store.dispatch("SET_LEER_CONTESTACION", { url: this.url_leido })
      //     .then((response) => {
      //       // console.log(response.data);
      //       Swal.fire({
      //         icon: 'success',
      //         title: 'Contestación Leída',
      //         confirmButtonText: "Aceptar",
      //         timer: 1000,
      //       })
      //       this.showPromocion()
      //       this.$router.push('/panel')
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.$swal({
      //         title: 'Error!!!',
      //         icon: 'error',
      //         timer: 1000,
      //       })
      //     });
      // },
      getFilePresignedUrl(item, tipo){
        this.progress = true
        let path = ''
        if (tipo == 'doc_apelaciones') {
          path = item.url
        }
        if (tipo == 'doc_sisgeo') {
          path = item.url_evidencia
        }
        if (tipo == 'video_apelaciones') {
          path = item.url_video_audiencia
        }
        // console.log(path)
        this.$store.dispatch("GET_PRESIGNED_URL", { 
          url: "/autorizacion/documento",
          params: {
            path_url: path,
            autorizacion_id: this.autorizacion.id,
            sala_id: this.autorizacion.sala_id,
          }
        }).then((response) => {
          // console.log(response.data.data);
          const link = document.createElement('a');
          // var showFile = response.data.data.presignedUrl // Pruebas local
          var showFile = JSON.parse(response.data.data.presignedUrl.body); // producción
          link.href = showFile;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
          }).catch(err => {
            this.progress = false
            console.log(err);
        });
      },
      // getAcuse(item, tipo){
      //   item.id = this.autorizacion.id
      //   this.progress = true
      //   this.$store.dispatch("GET_ACUSE", { url: this.url }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.setAttribute('target' ,'_blank');
      //     document.body.appendChild(link);
      //     link.click();
      //     this.progress = false
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
